export default "__VITE_ASSET__C2Aw7GY9__"